import { Controller } from "stimulus"

// Keeps a form's submit button disabled until at least one of its checkboxes or radios is checked (nothing
// else in the app gates a submit on a choice; typed_confirmation is for a typed phrase). Listens to the form's
// change events, since the toggles are rendered by a component that takes no data attributes.
export default class extends Controller {
  static targets = ["submit"]

  connect() {
    this.update()
  }

  update() {
    const checked = this.element.querySelectorAll("input[type=checkbox]:checked, input[type=radio]:checked")
    this.submitTarget.disabled = checked.length === 0
  }
}
